import serviceHandler from "@/helpers/handlers/service";
import QuestionAndAnswersService from "@/services/questionsAndAnswers.js";

export default class QAndAServiceManager {
  constructor(isAnswer) {
    this.isAnswer = isAnswer;
    this.methods = this.initializeMethods(isAnswer);
  }

  initializeMethods(isAnswer) {
    const methodMap = {
      ANSWER: {
        update: QuestionAndAnswersService.updateAnswer,
        delete: QuestionAndAnswersService.deleteAnswer,
        create: QuestionAndAnswersService.createAnswerByQuestionId
      },
      QUESTION: {
        update: QuestionAndAnswersService.updateQuestion,
        delete: QuestionAndAnswersService.deleteQuestion,
        create: QuestionAndAnswersService.createAnswerByQuestionId
      }
    };
    return methodMap[isAnswer ? "ANSWER" : "QUESTION"];
  }

  async update(id, payload) {
    return serviceHandler(this.methods.update(id, payload));
  }

  async delete(id) {
    return serviceHandler(this.methods.delete(id));
  }

  async create(payload) {
    return serviceHandler(
      !this.isAnswer
        ? this.methods.create(payload.questionId, payload)
        : this.methods.create(payload)
    );
  }
}
